
<script>
import store from '@/store/index.js';
import { EventBus } from '@/event-bus';

export default {
    props: {
    },

    data() {
        return {
        observers: [],
        };
    },

    computed: {
        contextMenuDisplay() {
            return this.$store.getters.contextMenuDisplay;
        },
        contextMenuOptions() {
             return this.$store.getters.contextMenuOptions;
        },
        contextMenuClass() {
             return this.$store.getters.contextMenuClass;
        },

        // tooltipPosition() {
        //     return this.$store.getters.tooltipPosition;
        // },

        styleCssToolTip() {
            let event = this.$store.getters.contextMenuEvent;
            let elementTarget = event.currentTarget

            if (event == null || elementTarget == undefined) return {};

            return {
                left: (event.pageX) + "px",
                top:  (event.pageY) + "px",
            }
        },
    },

    methods: {
        clickOption(name,event) {
            console.log('clickOption',name,event)
            event.stopPropagation();
            EventBus.$emit("receveidEventContextMenu-" + this.$store.getters.contextMenuId, name);
            this.hideContextMenu()
        },

        handleClickOutside(event) {
            const targetElement = this.$refs.contextMenu;
            if (!targetElement.contains(event.target)) {
                this.hideContextMenu()
            }
        },

        hideContextMenu() {
            this.$store.commit('updateContextMenuDisplay', false);
        }
    },

    watch : {
        contextMenuDisplay() {
          
            if (this.contextMenuDisplay) {   
                window.addEventListener('click', this.handleClickOutside);
                document.querySelector('body').addEventListener("mouseleave", this.hideContextMenu);
            }else{
                console.log("remove event")
                window.removeEventListener("click", this.handleClickOutside, false);
                document.querySelector('body').removeEventListener("mouseleave", this.hideContextMenu, false);
            }
        }
    },

    beforeDestroy() {
        window.removeEventListener("click", this.handleClickOutside, false);
        document.querySelector('body').removeEventListener("mouseleave", this.hideContextMenu, false);
    },
   

}

</script>

<template>
    <div v-if="contextMenuDisplay"  ref="contextMenu" :class="['container-context-menu',contextMenuClass]" :style="styleCssToolTip">
        <div class="option" v-for="(option,index) in contextMenuOptions" @click="clickOption(option.name, $event)" v-html="option.label" :key="'option'+index">
         
        </div>
    </div>
</template>
